import CardCommon from '@op/components/CardCommon';
import React, { useEffect } from 'react';
import { Modal, notification, Text } from 'tea-component';
import { useIntl } from 'umi';

export default function HistoricalPrompt({
  closeHistoricalPrompt,
  setPrompt,
  userPromptList,
  loading,
  getUserHistoryPrompt,
}: {
  closeHistoricalPrompt: () => void;
  setPrompt: (value: string) => void;
  userPromptList: Array<any>;
  loading: boolean;
  getUserHistoryPrompt: () => void;
}) {
  const { formatMessage } = useIntl();

  useEffect(() => {
    getUserHistoryPrompt();
  }, []);

  return (
    <Modal.Body>
      <CardCommon
        contentCard
        empty={userPromptList.length === 0}
        loading={loading}
        emptyHeight={460}
        loadingHeight={460}
      >
        {userPromptList.map((item) => {
          return (
            <Text
              tooltip={formatMessage({ id: 'Click to apply' })}
              key={item.update_time}
              onClick={() => {
                setPrompt(item.prompt_detail);
                notification.success({
                  description: formatMessage({ id: 'New Prompt Applied' }),
                });
                closeHistoricalPrompt();
              }}
            >
              <div className="dbo-historical-modal-item">
                <div className="dbo-historical-modal-date">
                  {item.update_time}
                </div>
                <div className="dbo-historical-modal-text">
                  {item.prompt_detail}
                </div>
              </div>
            </Text>
          );
        })}
      </CardCommon>
    </Modal.Body>
  );
}
